import * as React from 'react';
import { connect } from 'react-redux';
import { connectSsr } from '@bart.sk-eshop/ssr-service';
import { __ } from '@bart.sk-eshop/react-i18n';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem, rgba } from 'polished';
import MetaTags from '../../../components/MetaTags/MetaTags';
import { getImagePath } from '../../../utilities/product';
import {
  HOMEPAGE_UNIQID,
  URL_CUSTOMER_CARD,
  URL_ESHOP_ENTRY,
  URL_SETS,
  UrlMapTypes,
} from '../../../constants';
import {
  canShowHomepageSkvelkoSearch,
  capitalizeFirstLetter,
  getSetUrl,
  getUrl,
  isHomepageEshopEnabled,
  isSkvelkoHomepageEnabled,
  loadGlobalMetaTags,
  prop,
} from '../../../utilities';
import UrlMapper, { UrlMapperView } from '../../UrlMapper/UrlMapper';
import {
  loadSkvelkoCities,
  loadUniversalSets,
  loadReviewsTexts,
  loadHomepagePromoBanners,
} from '../../Home/actions';
import { loadDefaultSettings } from '../../App/actions';
import SkvelkoBox from '../SkvelkoBox';
import {
  Page,
  ContentBox,
  Section,
  PillButton,
  OutlineButton,
  YellowButton,
  pillButtonBase,
  PromoBanners,
  SELF_PROMO_BANNERS,
  ProductCard,
  ProductFolder,
  ProductImg,
  ProductBody,
  ProductList,
  ProductItem,
  ProductButtonRow,
  CarouselWrap,
  CarouselTrack,
  OverlayArrow,
  MobileArrows,
  ArrowButton,
  Chevron,
  useCarousel,
  headingInset,
  audienceColor,
  SITE_ORIGIN,
  StructuredData,
} from '../_shared';

/* ------------------------------------------------------------------ *
 * "Pre seba" (retail) homepage. Pixel rebuild of the Figma design
 * (desktop node 3146-20154, mobile 3256-22621). Replaces the legacy
 * `Home` container at the index route. Mobile-first; desktop kicks in
 * at `md` (992px). Shares scaffolding, buttons, promo banners, folder
 * cards and the carousel with the other audience-intro pages via
 * ../_shared. No bottom red footer banner (by request).
 * Sections: Skvelko finder, promo (Darček/Akciová), universal-sets
 * slider + promo banners, product offer (category folders), references.
 * ------------------------------------------------------------------ */

const ASSET = '/images/self-intro';

const REVIEWS_URL =
  'https://www.google.com/search?sca_esv=8706040363b6e574&cs=0&sxsrf=APpeQnsrILLJda9CbA2EL1MjNPpnuZtWUw:1783075421838&uds=AJ5uw1_a2D0D09lxm8gpKKOTUn4ry-uR49j2s5DSfNy8q5h2YFu2W5DkCbmhHcik_yptHFRhYSkKjUBZBk0iPe4FCHm8-aTBjqKemmVndvZ9L0-ISFuYb6ppkF6lBSR_z5b03KrusWV_tUYaoPnz8DeUkKcfCpQy7A&q=Daffer+spol.+Ltd.+Reviews&si=APenkKn5T4YN59srr511wD6k6Pufj9DEzRUvB1XJSwUeeT5afsyAQneZtxlfdE8Jw_1jJy8K2a8_7TVfLwxgXjJlAvpRQ_V8steCCetTTqKnvQrKh3pz09PCEZQS9P1xozxCu_X5xHx2&hl=en-SK&sa=X&ved=2ahUKEwiGiP_IqbaVAxUEOXoKHaVQPNEQ_4MLegQIEBAQ&biw=1920&bih=1018&dpr=1';

const PINK = audienceColor('pink');
const MAROON = audienceColor('maroon');
const RED = audienceColor('red');
const RED_CTA = audienceColor('redCta');
const DARK = audienceColor('dark');

const SectionTitle = styled.h2`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.headings};
  font-weight: 700;
  font-size: ${rem(26)};
  line-height: 1.3;
  color: ${DARK};
  ${({ theme }) => theme.media('md')} {
    font-size: ${rem(32)};
  }
`;

// Dočasne skryté — banner sa na stránke nezobrazuje
// const DeliveryBanner = styled.div`
//   display: flex;
//   align-items: center;
//   gap: ${rem(12)};
//   padding: ${rem(16)};
//   border-radius: ${rem(16)};
//   background: ${PINK};
//   color: ${DARK};
//
//   @media (min-width: 426px) {
//     gap: ${rem(16)};
//     padding: ${rem(16)} ${rem(24)};
//     border-radius: ${rem(24)};
//   }
//   ${({ theme }) => theme.media('md')} {
//     justify-content: center;
//     padding: ${rem(16)} ${rem(40)};
//   }
// `;
//
// const DeliveryIcon = styled.img`
//   flex: 0 0 auto;
//   width: ${rem(48)};
//   height: ${rem(48)};
//   @media (min-width: 426px) {
//     width: ${rem(56)};
//     height: ${rem(56)};
//   }
// `;
//
// const DeliveryText = styled.p`
//   margin: 0;
//   font-size: ${rem(18)};
//   line-height: 1.44;
//   @media (max-width: 425px) {
//     font-size: ${rem(16)};
//   }
//   @media (min-width: 426px) {
//     font-size: ${rem(17)};
//   }
//   @media (min-width: 426px) and (max-width: 768px) {
//     font-size: ${rem(13)};
//   }
//   @media (min-width: 769px) and (max-width: 991px) {
//     font-size: ${rem(15)};
//   }
// `;
//
// const DeliveryLead = styled.strong`
//   font-weight: 700;
// `;
//
// /* The strip belongs visually with the SupportBanner right below it, so trim
//  * the ContentBox column gap (40 below `md`, 48 above) down to 8px on phones
//  * and 24px from tablet up. */
// const DeliverySection = styled(Section)`
//   margin-bottom: -${rem(32)};
//   @media (min-width: 426px) {
//     margin-bottom: -${rem(16)};
//   }
//   ${({ theme }) => theme.media('md')} {
//     margin-bottom: -${rem(24)};
//   }
// `;
//
// const DeliveryBannerSection = () => (
//   <DeliverySection>
//     <DeliveryBanner>
//       <DeliveryIcon
//         src={`${ASSET}/ico-delivery.svg`}
//         alt=""
//         aria-hidden="true"
//         width={56}
//         height={56}
//         decoding="async"
//       />
//       <DeliveryText>
//         <DeliveryLead>{__('Dodanie do 1.9.2026 vám garantujeme')}</DeliveryLead>
//         {__(
//           ', ak uhradíte objednávku alebo zvolíte dobierku do 30. 8. 2026 (vrátane).',
//         )}
//       </DeliveryText>
//     </DeliveryBanner>
//   </DeliverySection>
// );

/* =================================================================== *
 * Section 0 — "Podporujeme vzdelávanie" banner above the Skvelko finder
 * (Figma EYC1yZsHVyd9gfX1: desktop 1328×100 strip, mobile 280×450 card).
 * Only the "Zistite ako" pill links to the support-education page.
 * Built like the SchoolsIntro / OrganizationsIntro hero cards: 16/24
 * card radius, a mobile photo box with a fixed aspect ratio fading into
 * the panel colour via a CSS gradient (a fixed height would over-crop
 * on wide "mobile" viewports), and a separate desktop photo element.
 * Desktop: photo strip on the left with a maroon wash on its edges,
 * then the red text panel overlapping it PromoBanner-style (negative
 * margin + own rounded corners, so the photo peeks behind the seam),
 * left-aligned text after the strip, white pill pinned right.
 * =================================================================== */

const SUPPORT_EDUCATION_URL = '/podporujeme-vzdelavanie';

const SupportBanner = styled.div`
  position: relative;
  z-index: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: ${rem(16)};
  background: ${RED_CTA};
  color: ${({ theme }) => theme.color.white};

  @media (min-width: 426px) {
    flex-direction: row;
    align-items: stretch;
    height: ${rem(100)};
    border-radius: ${rem(24)};
  }
  /* Narrow desktop: text + button don't fit side by side, so the button
   * stacks under the text and the banner grows taller than the 100px strip. */
  @media (min-width: 426px) and (max-width: 768px) {
    height: auto;
  }
`;

const SupportPhotoMobile = styled.div`
  width: 100%;
  aspect-ratio: 571 / 443;
  background: ${({ theme }) =>
      `linear-gradient(180deg, ${rgba(
        theme.color.audience.maroon,
        0.55,
      )} 0%, ${rgba(theme.color.audience.maroon, 0)} 18%)`},
    url('${ASSET}/support.webp') center / cover no-repeat;
  /* "height 54%": a percentage height can't resolve here (the column-mode
   * banner has no fixed height), so express it as height = 54% of the
   * width via aspect-ratio — ~172px @320 … ~229px @425. */
  @media (min-width: 320px) and (max-width: 425px) {
    aspect-ratio: 100 / 54;
  }
  @media (min-width: 426px) {
    display: none;
  }
`;

const SupportPhotoDesktop = styled.div`
  display: none;
  @media (min-width: 426px) {
    display: block;
    flex: 0 0 28%;
    background: ${({ theme }) =>
        `linear-gradient(90deg, ${rgba(
          theme.color.audience.maroon,
          0.55,
        )} 0%, ${rgba(theme.color.audience.maroon, 0)} 18%, ${rgba(
          theme.color.audience.maroon,
          0,
        )} 62%, ${rgba(theme.color.audience.maroon, 0.85)} 100%)`},
      url('${ASSET}/support.webp') center 30% / cover no-repeat;
  }
  @media (min-width: 426px) and (max-width: 768px) {
    flex: 0 0 34%;
    width: 34%;
  }
`;

const SupportBody = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: ${rem(24)};
  margin-top: -${rem(16)};
  background: ${RED_CTA};
  border-radius: ${rem(16)} ${rem(16)} 0 0;
  padding: ${rem(20)} ${rem(20)} ${rem(20)};
  @media (min-width: 426px) {
    flex-direction: row;
    align-items: center;
    margin-top: 0;
    margin-left: -${rem(24)};
    border-radius: ${rem(24)};
    padding: 0 ${rem(24)};
  }
  /* Narrow desktop: stack text above the button. */
  @media (min-width: 426px) and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${rem(12)};
    padding: ${rem(16)} ${rem(24)};
  }
`;

const SupportText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
  @media (min-width: 426px) {
    margin-left: ${rem(32)};
    gap: ${rem(2)};
  }
  /* Narrow desktop: no left indent when stacked under the photo. */
  @media (min-width: 426px) and (max-width: 768px) {
    margin-left: 0;
  }
  /* Row layout below the wide desktop still shares the strip with the
   * pinned button — trim the indent so the text has room. */
  @media (min-width: 769px) and (max-width: 991px) {
    margin-left: ${rem(16)};
  }
`;

const SupportTitle = styled.strong`
  display: block;
  font-family: ${({ theme }) => theme.fonts.headings};
  font-size: ${rem(26)};
  font-weight: 700;
  line-height: 1.3;
  /* Phones: smaller heading. */
  @media (max-width: 425px) {
    font-size: ${rem(22)};
  }
  @media (min-width: 426px) {
    font-size: ${rem(24)};
  }
  /* Shrink in the stacked band and the tight row band. */
  @media (min-width: 426px) and (max-width: 768px) {
    font-size: ${rem(17)};
  }
  @media (min-width: 769px) and (max-width: 991px) {
    font-size: ${rem(20)};
  }
`;

const SupportDesc = styled.span`
  display: block;
  font-size: ${rem(18)};
  line-height: 1.44;
  /* Phones: smaller description. */
  @media (max-width: 425px) {
    font-size: ${rem(16)};
  }
  @media (min-width: 426px) {
    font-size: ${rem(17)};
  }
  /* Shrink in the stacked band and so the two-line desc fits the strip. */
  @media (min-width: 426px) and (max-width: 768px) {
    font-size: ${rem(13)};
  }
  @media (min-width: 769px) and (max-width: 991px) {
    font-size: ${rem(15)};
  }
`;

const SupportCta = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  min-height: ${rem(48)};
  padding: ${rem(10)} ${rem(32)};
  border-radius: ${rem(999)};
  background: ${({ theme }) => theme.color.white};
  color: ${DARK};
  font-size: ${rem(16)};
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
  text-decoration: none;
  transition: background 0.15s ease;

  &:hover {
    color: ${DARK};
    background: ${audienceColor('grayLighter')};
    text-decoration: none;
  }

  @media (min-width: 426px) {
    align-self: center;
    flex: 0 0 auto;
    /* Pin to the banner's right edge (the text block sits left). */
    margin-left: auto;
    /* Figma pill ≈ 205×43: wider and a touch flatter than the shared 48px. */
    min-width: ${rem(200)};
    min-height: ${rem(42)};
  }
  /* Narrow desktop: button sits left, under the text (not pinned right). */
  @media (min-width: 426px) and (max-width: 768px) {
    align-self: flex-start;
    margin-left: 0;
  }
`;

const SupportBannerSection = () => (
  <Section>
    <SupportBanner>
      <SupportPhotoDesktop aria-hidden="true" />
      <SupportPhotoMobile aria-hidden="true" />
      <SupportBody>
        <SupportText>
          <SupportTitle>{__('Podporujeme vzdelávanie')}</SupportTitle>
          <SupportDesc>
            {__('Každý deň pomáhame vytvárať lepšie podmienky na učenie')}
          </SupportDesc>
        </SupportText>
        <SupportCta to={SUPPORT_EDUCATION_URL}>{__('Zistite ako')}</SupportCta>
      </SupportBody>
    </SupportBanner>
  </Section>
);

interface PromoBoxColors {
  textBg: string;
  title: string;
  text: string;
  ctaBg: string;
  ctaBgHover: string;
  ctaText: string;
  ctaTextHover: string;
}

interface PromoBoxData {
  slot: number;
  title: string;
  text: string;
  ctaText: string;
  ctaUrl: string;
  image: string | null;
  colors: PromoBoxColors;
}

const PROMO_BOX_BIG_COLORS: PromoBoxColors = {
  textBg: '#F4C900',
  title: '#231F20',
  text: '#231F20',
  ctaBg: '#231F20',
  ctaBgHover: '#000000',
  ctaText: '#FFFFFF',
  ctaTextHover: '#FFFFFF',
};

const PROMO_BOX_SMALL_COLORS: PromoBoxColors = {
  textBg: '#FFFFFF',
  title: '#231F20',
  text: '#444444',
  ctaBg: '#FFFFFF',
  ctaBgHover: '#F2F2F2',
  ctaText: '#231F20',
  ctaTextHover: '#231F20',
};

const HEX_COLOR = /^#[0-9a-f]{6}$/i;
const DAFFER_ORIGIN = /^https?:\/\/(www\.)?daffer\.sk/i;
const EXTERNAL_URL = /^https?:\/\//i;

const toPromoBoxData = (
  banners: any[],
  slot: number,
  defaults: PromoBoxColors,
): PromoBoxData | null => {
  const banner = banners.find((b: any) => Number(b && b.b_sort) === slot);
  const title = String(prop(banner, 'b_name', '') || '').trim();
  if (!title) {
    return null;
  }

  const savedColors = prop(banner, 'b_colors') || {};
  const colors = { ...defaults };
  (Object.keys(defaults) as (keyof PromoBoxColors)[]).forEach((key) => {
    if (HEX_COLOR.test(savedColors[key])) {
      colors[key] = savedColors[key];
    }
  });

  const image = String(banner.b_path || '').replace(/^banners\/?$/, '');

  return {
    slot,
    title,
    text: banner.b_description || '',
    ctaText: banner.b_text || '',
    ctaUrl: banner.b_url || '',
    image: image || null,
    colors,
  };
};

const promoBoxImageUrl = (path: string, width: number) =>
  `url("${getImagePath(
    path,
    { width, height: 0 },
    true,
    false,
    false,
    true,
  )}")`;

const promoBoxStyle = (
  box: PromoBoxData,
  mobileImageWidth: number,
  desktopImageWidth: number,
): React.CSSProperties =>
  ({
    '--promo-text-bg': box.colors.textBg,
    '--promo-title': box.colors.title,
    '--promo-text': box.colors.text,
    '--promo-cta-bg': box.colors.ctaBg,
    '--promo-cta-bg-hover': box.colors.ctaBgHover,
    '--promo-cta-text': box.colors.ctaText,
    '--promo-cta-text-hover': box.colors.ctaTextHover,
    ...(box.image
      ? {
          '--promo-image': promoBoxImageUrl(box.image, mobileImageWidth),
          '--promo-image-desktop': promoBoxImageUrl(
            box.image,
            desktopImageWidth,
          ),
        }
      : {}),
  } as React.CSSProperties);

const PromoBoxesBand = styled.section`
  position: relative;
  z-index: 0;
  width: 100%;
  padding: ${rem(16)} ${rem(12)} ${({ $tucked }) => rem($tucked ? 32 : 16)};
  background: ${audienceColor('creamYellow')};
  border-radius: ${rem(16)} ${rem(16)} 0 0;
  ${({ theme }) => theme.media('md')} {
    padding: ${rem(40)} ${rem(60)} ${({ $tucked }) => rem($tucked ? 82 : 40)};
    border-radius: ${rem(42)} ${rem(42)} 0 0;
  }
`;

const PromoBoxesLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  ${({ theme }) => theme.media('md')} {
    flex-direction: row;
    align-items: stretch;
    gap: ${rem(32)};
  }
`;

const PromoBoxCta = styled(Link)`
  ${pillButtonBase};
  background: var(--promo-cta-bg);
  color: var(--promo-cta-text);

  &:hover,
  &:focus {
    background: var(--promo-cta-bg-hover);
    color: var(--promo-cta-text-hover);
    text-decoration: none;
  }
`;

const PromoBoxOutlineCta = styled(PromoBoxCta)`
  min-height: ${rem(40)};
  padding: ${rem(6)} ${rem(22)};
  border: ${rem(2)} solid var(--promo-cta-text);

  &:hover,
  &:focus {
    border-color: var(--promo-cta-text-hover);
  }

  ${({ theme }) => theme.media('md')} {
    min-height: ${rem(44)};
  }
`;

interface PromoBoxCtaButtonProps {
  box: PromoBoxData;
  outline?: boolean;
}

const PromoBoxCtaButton = ({
  box,
  outline = false,
}: PromoBoxCtaButtonProps) => {
  if (!box.ctaText || !box.ctaUrl) {
    return null;
  }
  const Button = outline ? PromoBoxOutlineCta : PromoBoxCta;
  const url = box.ctaUrl.replace(DAFFER_ORIGIN, '');
  return EXTERNAL_URL.test(url) ? (
    <Button as="a" href={url}>
      {box.ctaText}
    </Button>
  ) : (
    <Button to={getUrl(url) || '/'}>{box.ctaText}</Button>
  );
};

const PromoBoxBig = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.media('md')} {
    flex: 760 1 0;
    min-width: 0;
    flex-direction: row;
    min-height: ${rem(504)};
    overflow: hidden;
    border-radius: ${rem(24)};
  }
`;

const PromoBoxBigImage = styled.div`
  aspect-ratio: 1 / 1;
  border-radius: ${rem(16)};
  background: var(--promo-image) center / cover no-repeat;
  ${({ theme }) => theme.media('xs')} {
    aspect-ratio: 3 / 2;
  }
  ${({ theme }) => theme.media('md')} {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    aspect-ratio: auto;
    border-radius: 0;
    background-image: var(--promo-image-desktop);
  }
`;

const PromoBoxBigPanel = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: ${rem(24)};
  padding: ${rem(24)} ${rem(20)};
  border-radius: ${rem(16)};
  background: var(--promo-text-bg);

  ${PromoBoxBigImage} + & {
    margin-top: -${rem(50)};
  }

  ${({ theme }) => theme.media('md')} {
    flex: 1 1 auto;
    justify-content: space-between;
    gap: ${rem(32)};
    padding: ${rem(40)} ${rem(28)} ${rem(32)};
    border-radius: ${rem(24)};

    ${PromoBoxBigImage} + & {
      flex: 0 0 54.34%;
      margin-top: 0;
    }
  }

  ${({ theme }) => theme.media('lg')} {
    padding: ${rem(60)} ${rem(40)} ${rem(48)};
  }
`;

const PromoBoxBigText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
`;

const PromoBoxBigTitle = styled.h2`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.headings};
  font-size: ${rem(32)};
  font-weight: 700;
  line-height: ${rem(40)};
  color: var(--promo-title);
  ${({ theme }) => theme.media('lg')} {
    font-size: ${rem(42)};
    line-height: ${rem(52)};
  }
`;

const PromoBoxBigTeaser = styled.p`
  margin: 0;
  font-size: ${rem(21)};
  line-height: ${rem(29)};
  color: var(--promo-text);
  ${({ theme }) => theme.media('lg')} {
    font-size: ${rem(24)};
    line-height: ${rem(32)};
  }
`;

const PromoBoxSmallColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  ${({ theme }) => theme.media('md')} {
    flex: 528 1 0;
    min-width: 0;
    gap: ${rem(32)};
  }
`;

const PromoBoxSmall = styled.div`
  display: flex;
  ${({ theme }) => theme.media('md')} {
    flex: 1 1 0;
    min-height: ${rem(237)};
  }
`;

const PromoBoxSmallImage = styled.div`
  flex: 0 0 ${rem(136)};
  margin-right: -${rem(16)};
  border-radius: ${rem(16)} 0 0 ${rem(16)};
  background: var(--promo-image) center / cover no-repeat;
  ${({ theme }) => theme.media('md')} {
    flex-basis: calc(32.2% + ${rem(24)});
    margin-right: -${rem(24)};
    border-radius: ${rem(24)} 0 0 ${rem(24)};
  }
`;

const PromoBoxSmallCard = styled.div`
  position: relative;
  z-index: 1;
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${rem(24)};
  padding: ${rem(16)};
  border-radius: ${rem(16)};
  background: var(--promo-text-bg);
  ${({ theme }) => theme.media('md')} {
    padding: ${rem(24)};
    border-radius: ${rem(24)};
  }
  ${({ theme }) => theme.media('lg')} {
    padding: ${rem(40)};
  }
`;

const PromoBoxSmallText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
`;

const PromoBoxSmallTitle = styled.h3`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.headings};
  font-size: ${rem(22)};
  font-weight: 700;
  line-height: ${rem(30)};
  color: var(--promo-title);
  ${({ theme }) => theme.media('lg')} {
    font-size: ${rem(26)};
    line-height: ${rem(36)};
  }
`;

const PromoBoxSmallTeaser = styled.p`
  margin: 0;
  font-size: ${rem(16)};
  font-weight: 600;
  line-height: ${rem(24)};
  color: var(--promo-text);
`;

interface PromoBoxesProps {
  banners: any[];
  tuckedBelow?: boolean;
}

const PromoBoxesBase = ({ banners, tuckedBelow }: PromoBoxesProps) => {
  const list = banners || [];
  const big = toPromoBoxData(list, 1, PROMO_BOX_BIG_COLORS);
  if (!big) {
    return null;
  }
  const smallBoxes = [2, 3]
    .map((slot) => toPromoBoxData(list, slot, PROMO_BOX_SMALL_COLORS))
    .filter((box): box is PromoBoxData => box !== null);

  return (
    <PromoBoxesBand $tucked={tuckedBelow}>
      <PromoBoxesLayout>
        <PromoBoxBig style={promoBoxStyle(big, 1080, 1520)}>
          {big.image ? <PromoBoxBigImage aria-hidden="true" /> : null}
          <PromoBoxBigPanel>
            <PromoBoxBigText>
              <PromoBoxBigTitle>{big.title}</PromoBoxBigTitle>
              {big.text ? (
                <PromoBoxBigTeaser>{big.text}</PromoBoxBigTeaser>
              ) : null}
            </PromoBoxBigText>
            <PromoBoxCtaButton box={big} />
          </PromoBoxBigPanel>
        </PromoBoxBig>
        {smallBoxes.length > 0 ? (
          <PromoBoxSmallColumn>
            {smallBoxes.map((box) => (
              <PromoBoxSmall
                key={box.slot}
                style={promoBoxStyle(box, 720, 720)}
              >
                {box.image ? <PromoBoxSmallImage aria-hidden="true" /> : null}
                <PromoBoxSmallCard>
                  <PromoBoxSmallText>
                    <PromoBoxSmallTitle>{box.title}</PromoBoxSmallTitle>
                    {box.text ? (
                      <PromoBoxSmallTeaser>{box.text}</PromoBoxSmallTeaser>
                    ) : null}
                  </PromoBoxSmallText>
                  <PromoBoxCtaButton box={box} outline />
                </PromoBoxSmallCard>
              </PromoBoxSmall>
            ))}
          </PromoBoxSmallColumn>
        ) : null}
      </PromoBoxesLayout>
    </PromoBoxesBand>
  );
};

const PromoBoxesSection = connect((state: any) => ({
  banners: prop(state.home, 'homepagePromoBanners', []),
}))(PromoBoxesBase);

/* =================================================================== *
 * Section 1 — Skvelko finder ("Zoznamy pomôcok na nový školský rok").
 * The yellow card + finder itself lives in ../SkvelkoBox — shared with
 * the Sets page search box (SkvelkoSearchBox).
 * =================================================================== */

const SkvelkoSection = () => (
  <Section>
    <SkvelkoBox />
  </Section>
);

/* =================================================================== *
 * Section 2 — Promo: "Darček k nákupu" (collage panel + white text card)
 * and "Akciová ponuka" (product photo + % overflowing a grey-topped card).
 * Full-bleed pink block. Figma node 3146-21138 (desktop) / 3256-22970 (mobile).
 * =================================================================== */

const CARD_SHADOW = `0 ${rem(6)} ${rem(60)} rgba(0, 0, 0, 0.06), 0 ${rem(
  4,
)} ${rem(8)} rgba(0, 0, 0, 0.04)`;

const PromoWrap = styled.section`
  width: 100%;
  background: ${PINK};
  border-radius: ${rem(16)} ${rem(16)} 0 0;
  padding: ${rem(16)} ${rem(12)} ${rem(40)};
  ${({ theme }) => theme.media('md')} {
    border-radius: ${rem(42)} ${rem(42)} 0 0;
    padding: ${rem(40)} ${rem(60)} ${rem(82)};
  }
  ${PromoBoxesBand} + & {
    position: relative;
    z-index: 1;
    margin-top: -${rem(32)};
  }
  ${({ theme }) => theme.media('md')} {
    ${PromoBoxesBand} + & {
      margin-top: -${rem(82)};
    }
  }
`;

const PromoInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(24)};
  ${({ theme }) => theme.media('md')} {
    flex-direction: row;
    align-items: stretch;
    gap: ${rem(32)};
  }
`;

// Dočasne skryté — pôvodná karta „Darček k nákupu“, nahradená kartou „Zákaznícka karta“
// /* ---- Darček k nákupu: collage panel (left / top) + white text card ---- */
//
// const DarcekCard = styled.div`
//   display: flex;
//   flex-direction: column;
//   overflow: hidden;
//   background: ${({ theme }) => theme.color.white};
//   border-radius: ${rem(12)};
//   box-shadow: ${CARD_SHADOW};
//   ${({ theme }) => theme.media('md')} {
//     flex: 871 1 0;
//     flex-direction: row;
//     border-radius: ${rem(24)};
//   }
// `;
//
// const DarcekImg = styled.div`
//   position: relative;
//   overflow: hidden;
//   width: 100%;
//   height: ${rem(240)};
//   background: ${RED_CTA};
//   ${({ theme }) => theme.media('md')} {
//     flex: 1 1 auto;
//     min-width: 0;
//     height: auto;
//     align-self: stretch;
//   }
// `;
//
// const DarcekCollage = styled.img`
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   max-width: 85%;
//   max-height: 85%;
//   transform: translate(-50%, -50%) rotate(-13deg);
// `;
//
// const DarcekBadge = styled.img`
//   position: absolute;
//   z-index: 1;
//   left: 0;
//   bottom: 0;
//   max-width: 44%;
//   max-height: 80%;
//   pointer-events: none;
// `;
//
// const DarcekBody = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: ${rem(24)};
//   padding: ${rem(24)} ${rem(20)};
//   ${({ theme }) => theme.media('md')} {
//     flex: 0 0 ${rem(421)};
//     padding: ${rem(32)} ${rem(40)};
//   }
// `;
//
// const PromoInfo = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: ${rem(12)};
// `;
//
// const GiftTag = styled.span`
//   align-self: flex-start;
//   display: inline-flex;
//   align-items: center;
//   gap: ${rem(6)};
//   border: ${rem(1)} solid ${RED};
//   border-radius: ${rem(999)};
//   padding: ${rem(6)} ${rem(12)};
//   font-size: ${rem(14)};
//   font-weight: 600;
//   line-height: 1.7;
//   color: ${RED_CTA};
//
//   img {
//     width: ${rem(20)};
//     height: ${rem(20)};
//   }
// `;
//
// const TitleAccent = styled.span`
//   color: ${RED};
// `;
//
// const DarcekPromoCard = () => (
//   <DarcekCard>
//     <DarcekImg aria-hidden="true">
//       <DarcekCollage
//         src={`${ASSET}/promo-darcek-collage.webp`}
//         alt=""
//         aria-hidden="true"
//         loading="lazy"
//         decoding="async"
//       />
//       <DarcekBadge
//         src={`${ASSET}/promo-darcek-badge.webp`}
//         alt=""
//         aria-hidden="true"
//         loading="lazy"
//         decoding="async"
//       />
//     </DarcekImg>
//     <DarcekBody>
//       <PromoInfo>
//         <GiftTag>
//           <img
//             src={`${ASSET}/ico-gift.svg`}
//             alt=""
//             aria-hidden="true"
//             loading="lazy"
//             decoding="async"
//           />
//           {__('Darček k nákupu')}
//         </GiftTag>
//         <PromoTitle>
//           <TitleAccent>
//             {__('Darček k nákupu')}
//             <br />
//             {__('nad 40 €')}
//           </TitleAccent>{' '}
//           {__('- vzdelávacie materiály pre vaše dieťa')}
//         </PromoTitle>
//         <PromoDesc>
//           {__(
//             'Pri nákupe nad 40 € získate darček - vzdelávacie materiály v hodnote 40 € - zadarmo',
//           )}
//         </PromoDesc>
//       </PromoInfo>
//       <PromoCta to={'/darcek-k-nakupu40'}>
//         {__('Zistiť viac o ponuke')}
//       </PromoCta>
//     </DarcekBody>
//   </DarcekCard>
// );

const CustomerCard = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: ${rem(12)};
  box-shadow: ${CARD_SHADOW};
  ${({ theme }) => theme.media('md')} {
    flex: 871 1 0;
    flex-direction: row;
    border-radius: ${rem(24)};
  }
`;

const CustomerCardImgPanel = styled(Link)`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: ${rem(252)};
  background: ${rgba('#000', 0.1)};
  ${({ theme }) => theme.media('md')} {
    flex: 0 0 50%;
    min-width: 0;
    height: auto;
    align-self: stretch;
  }
`;

const CustomerCardImg = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: auto;
  height: auto;
  max-width: 83.25%;
  max-height: 69.28%;
  margin: auto;
  border-radius: 5.3% / 8.41%;
  box-shadow: 0 ${rem(3)} ${rem(18)} rgba(0, 0, 0, 0.16);
  ${({ theme }) => theme.media('md')} {
    max-width: 71.89%;
    max-height: 52.85%;
  }
`;

const CustomerCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(24)};
  padding: ${rem(24)} ${rem(20)};
  background: ${({ theme }) => theme.color.white};
  ${({ theme }) => theme.media('md')} {
    flex: 1 1 0;
    min-width: 0;
    padding: ${rem(32)} ${rem(40)};
  }
`;

const CustomerCardText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
`;

const PromoTitle = styled.h2`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.headings};
  font-size: ${rem(22)};
  font-weight: 700;
  line-height: 1.36;
  color: ${MAROON};
  ${({ theme }) => theme.media('md')} {
    font-size: ${rem(26)};
  }
`;

const PromoTitleRed = styled(PromoTitle)`
  color: ${RED};
`;

const PromoDesc = styled.p`
  margin: 0;
  font-size: ${rem(18)};
  line-height: 1.44;
  color: ${DARK};
`;

const PromoCta = styled(PillButton)`
  ${({ theme }) => theme.media('md')} {
    margin-top: auto;
  }
`;

/* ---- Akciová ponuka: grey-topped card with % + product photo overflowing ---- */

const AkciaCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  /* Push the card down so the product photo / % can overflow above its top. */
  margin-top: ${rem(50)};
  border-radius: ${rem(16)};
  ${({ theme }) => theme.media('md')} {
    flex: 417 1 0;
    border-radius: ${rem(24)};
  }
`;

const AkciaGrey = styled.img`
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  height: auto;
`;

const AkciaPhoto = styled.img`
  position: absolute;
  z-index: 2;
  top: ${rem(-46)};
  right: ${rem(-4)};
  width: 64%;
  height: auto;
  filter: drop-shadow(0 ${rem(4)} ${rem(4)} rgba(0, 0, 0, 0.16));
  ${({ theme }) => theme.media('md')} {
    top: ${rem(-64)};
    right: ${rem(-6)};
    width: 70%;
  }
`;

const AkciaBody = styled.div`
  position: relative;
  z-index: 3;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: ${rem(24)};
  padding: ${rem(24)} ${rem(20)};
  background: ${({ theme }) => theme.color.white};
  border-radius: 0 0 ${rem(16)} ${rem(16)};
  ${({ theme }) => theme.media('md')} {
    gap: ${rem(32)};
    padding: ${rem(32)} ${rem(40)};
    border-radius: 0 0 ${rem(24)} ${rem(24)};
  }
`;

const AkciaText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
`;

const scrollToTopAfterNavigation = () => {
  // Deferred past Router onUpdate (routes.tsx), which stores the current scrollY for back navigation.
  setTimeout(() => window.scrollTo(0, 0), 0);
};

const CustomerCardPromo = () => (
  <CustomerCard>
    <CustomerCardImgPanel
      to={URL_CUSTOMER_CARD}
      onClick={scrollToTopAfterNavigation}
      tabIndex={-1}
      aria-hidden="true"
    >
      <CustomerCardImg
        src={`${ASSET}/promo-zakaznicka-karta.webp`}
        width={789}
        height={497}
        alt=""
        loading="lazy"
        decoding="async"
      />
    </CustomerCardImgPanel>
    <CustomerCardBody>
      <CustomerCardText>
        <PromoTitleRed>{__('Zákaznícka karta')}</PromoTitleRed>
        <PromoDesc>
          {__(
            'Získate 20 % zľavu na prvý nákup a 5 % zľavu pri každom ďalšom nákupe',
          )}
        </PromoDesc>
      </CustomerCardText>
      <PromoCta to={URL_CUSTOMER_CARD} onClick={scrollToTopAfterNavigation}>
        {__('Požiadať o vydanie karty')}
      </PromoCta>
    </CustomerCardBody>
  </CustomerCard>
);

const PromoSection = () => (
  <PromoWrap>
    <PromoInner>
      {/* <DarcekPromoCard /> */}
      <CustomerCardPromo />

      <AkciaCard>
        <AkciaGrey
          src={`${ASSET}/promo-akcia-grey.webp`}
          width={834}
          height={240}
          alt=""
          aria-hidden="true"
          loading="lazy"
          decoding="async"
        />
        <AkciaPhoto
          src={`${ASSET}/promo-akcia-photo.webp`}
          alt=""
          aria-hidden="true"
          loading="lazy"
          decoding="async"
        />
        <AkciaBody>
          <AkciaText>
            <PromoTitleRed>{__('Akciová ponuka')}</PromoTitleRed>
            <PromoDesc>
              {__('Pozrite si našu aktuálnu akciovú ponuku so zľavami.')}
            </PromoDesc>
          </AkciaText>
          <PromoCta to={'/akcia2'}>{__('Zistiť viac o ponuke')}</PromoCta>
        </AkciaBody>
      </AkciaCard>
    </PromoInner>
  </PromoWrap>
);

/* =================================================================== *
 * Section 3 — Universal sets slider + the Doprava/Sieť promo banners.
 * Cards reuse the shared yellow "folder" pattern.
 * =================================================================== */

const SliderSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${rem(32)};
  /* The scroll track clips overflow-y (a scroll container clips both axes), so
     both the cards' bottom shadow AND the product images poking 40px above the
     folder (Figma) would get cut off. Reserve room on both sides inside the
     track; the negative margin cancels the top room so header spacing stays put.
     (Higher specificity than the track's own md padding shorthand.) */
  & ${CarouselTrack} {
    padding-top: ${rem(40)};
    margin-top: -${rem(40)};
    padding-bottom: ${rem(32)};
  }
  /* The track already reserves 32px below the cards (shadow room), so pull the
     mobile arrows up to avoid a doubled gap. */
  & ${MobileArrows} {
    margin-top: -${rem(24)};
  }
`;

const SliderStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(24)};
`;

const SetsSection = styled(SliderSection)`
  position: relative;
  z-index: 1;
  background: ${audienceColor('bgGrayLight')};
  border-radius: ${rem(24)} ${rem(24)} 0 0;
  margin-top: -${rem(40)};
  padding: ${rem(16)} 0 ${rem(40)};
  ${({ theme }) => theme.media('md')} {
    border-radius: ${rem(42)} ${rem(42)} 0 0;
    margin-top: -${rem(82)};
    padding: ${rem(40)} 0 ${rem(82)};
  }
  /* Figma: the sets-slider arrows are dark (not the default red). Scoped to this
     section — the Ponuka slider keeps the red arrows. Both desktop overlay arrows
     and mobile arrows carry the base OverlayArrow / ArrowButton class. */
  & ${OverlayArrow}, & ${ArrowButton} {
    background: ${DARK};
    &:hover {
      background: ${({ theme }) => theme.color.black};
    }
  }
`;

const PonukaWrap = styled(SliderSection)`
  position: relative;
  z-index: 2;
  background: ${({ theme }) => theme.color.white};
  border-radius: ${rem(24)} ${rem(24)} 0 0;
  margin-top: -${rem(40)};
  padding: ${rem(16)} 0 ${rem(40)};
  ${({ theme }) => theme.media('md')} {
    border-radius: ${rem(42)} ${rem(42)} 0 0;
    margin-top: -${rem(82)};
    /* 50 = 40 gap + 42 radius − 32 shadow room already in the track. */
    padding: ${rem(40)} 0 ${rem(50)};
  }
`;

const SliderHeader = styled.div`
  padding: 0 ${rem(16)};
  ${headingInset}
  /* Above the track's (transparent) top padding zone so the header button stays
     clickable where the two overlap. */
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
  ${({ theme }) => theme.media('md')} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${rem(24)};
    padding: 0 ${rem(56)};
  }
`;

const DarkOutlineButton = styled(OutlineButton)`
  display: none;
  border-color: ${DARK};
  color: ${DARK};
  ${({ theme }) => theme.media('md')} {
    display: inline-flex;
    flex: 0 0 auto;
  }
  &:hover {
    color: ${DARK};
    background: rgba(0, 0, 0, 0.04);
  }
`;

const MobileSetsButton = styled(OutlineButton)`
  /* Full width within the section gutter (Figma), label centred. */
  align-self: stretch;
  justify-content: center;
  margin: 0 ${rem(16)};
  border-color: ${DARK};
  color: ${DARK};
  &:hover {
    color: ${DARK};
    background: rgba(0, 0, 0, 0.04);
  }
  ${({ theme }) => theme.media('md')} {
    display: none;
  }
`;

const SlideCard = styled(ProductCard)`
  flex: 0 0 ${rem(240)};
  scroll-snap-align: start;
  ${({ theme }) => theme.media('md')} {
    flex: 0 0 ${rem(260)};
  }
`;

const SetLabel = styled.span`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: ${rem(8)};
  border: ${rem(1)} solid ${DARK};
  border-radius: ${rem(999)};
  padding: ${rem(6)} ${rem(12)};
  font-size: ${rem(14)};
  font-weight: 600;
  line-height: 1.7;
  color: ${DARK};

  img {
    width: ${rem(20)};
    height: ${rem(20)};
  }
`;

const SetImg = styled(ProductImg)`
  width: ${rem(180)};
  height: ${rem(180)};
  max-width: none;
  max-height: none;
  margin-bottom: -${rem(40)};
`;

const SetBody = styled(ProductBody)`
  box-shadow: ${CARD_SHADOW};
`;

const SetName = styled.h3`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.headings};
  font-size: ${rem(20)};
  font-weight: 700;
  line-height: 1.3;
  color: ${DARK};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const SlideOverlayArrow = styled(OverlayArrow)`
  ${({ theme }) => theme.media('md')} {
    top: calc(50% - ${rem(16)});
  }
`;

interface SetsProps {
  universalSets: any[];
}

const setSchoolTypeSuffix = (set: any): string => {
  const school = String(
    set.schoolName || set.schoolFullName || '',
  ).toLowerCase();
  if (school.indexOf('stredn') !== -1 || school.indexOf('sš') !== -1) {
    return ' stredná škola';
  }
  if (school.indexOf('základn') !== -1 || school.indexOf('zš') !== -1) {
    return ' ZŠ';
  }
  return '';
};

const UniversalSetsBase = ({ universalSets }: SetsProps) => {
  const { carouselRef, canLeft, canRight, updateArrows, scroll } =
    useCarousel(272);

  React.useEffect(() => {
    updateArrows();
  }, [universalSets, updateArrows]);

  const sets = universalSets || [];

  return (
    <SetsSection>
      <SliderHeader>
        <SectionTitle>{__('Univerzálne sady školských potrieb')}</SectionTitle>
        <DarkOutlineButton to={URL_SETS}>
          {__('Vyhľadať sadu podľa školy')}
        </DarkOutlineButton>
      </SliderHeader>

      {sets.length > 0 && (
        <UniversalSetsSlider>
          <CarouselWrap>
            <CarouselTrack ref={carouselRef} onScroll={updateArrows}>
              {sets.map((set: any, i: number) => (
                <SlideCard key={set.id}>
                  <ProductFolterWrapper>
                    <SetImg
                      src={`${getImagePath(`images/uni_set_${i % 13}.jpg`, {
                        width: 400,
                        height: 400,
                      })}&transparent=1`}
                      alt=""
                      aria-hidden="true"
                      loading="lazy"
                      decoding="async"
                    />
                  </ProductFolterWrapper>
                  <SetBody>
                    <SetLabel>
                      <img
                        src={`${ASSET}/ico-grid.svg`}
                        alt=""
                        aria-hidden="true"
                        loading="lazy"
                        decoding="async"
                      />
                      {__('Univerzálna sada')}
                    </SetLabel>
                    <SetName>
                      {set.fullName
                        ? `${set.fullName}${setSchoolTypeSuffix(set)}`
                        : set.schoolName}
                    </SetName>
                    <ProductButtonRow>
                      <YellowButton to={getSetUrl(set.id)}>
                        {__('Detail sady')}
                      </YellowButton>
                    </ProductButtonRow>
                  </SetBody>
                </SlideCard>
              ))}
            </CarouselTrack>
            <SlideOverlayArrow
              type="button"
              className={`left${canLeft ? '' : ' hidden'}`}
              onClick={() => scroll(-1)}
              aria-label={__('Predošlé')}
            >
              <Chevron dir="left" />
            </SlideOverlayArrow>
            <SlideOverlayArrow
              type="button"
              className={`right${canRight ? '' : ' hidden'}`}
              onClick={() => scroll(1)}
              aria-label={__('Ďalšie')}
            >
              <Chevron dir="right" />
            </SlideOverlayArrow>
          </CarouselWrap>
          <MobileArrows>
            <ArrowButton onClick={() => scroll(-1)} aria-label={__('Predošlé')}>
              <Chevron dir="left" />
            </ArrowButton>
            <ArrowButton onClick={() => scroll(1)} aria-label={__('Ďalšie')}>
              <Chevron dir="right" />
            </ArrowButton>
          </MobileArrows>
          <MobileSetsButton to={URL_SETS}>
            {__('Vyhľadať sadu podľa školy')}
          </MobileSetsButton>
        </UniversalSetsSlider>
      )}

      <PromoBanners wideInset={false} banners={SELF_PROMO_BANNERS} />
    </SetsSection>
  );
};

const UniversalSets = connect((state: any) => ({
  universalSets: prop(state.home, 'universalSets', []),
}))(UniversalSetsBase);

/* =================================================================== *
 * Section 4 — Ponuka produktov: the homepage's main categories as pink
 * "folder" cards (subcategory links + "Zobraziť všetko"), in a slider.
 * =================================================================== */

const PonukaTitle = styled(SectionTitle)`
  padding: 0 ${rem(16)};
  ${headingInset}
  /* Above the track's top padding zone (see SliderSection). */
  position: relative;
  z-index: 1;
  ${({ theme }) => theme.media('md')} {
    padding: 0 ${rem(56)};
  }
`;

const PonukaTitleAccent = styled.span`
  color: ${RED};
`;

const ProductFolterWrapper = styled(ProductFolder)`
  height: ${rem(95)};
`;

const CatFolder = styled(ProductFolterWrapper)`
  background: ${PINK};
`;

const CatImg = styled(ProductImg)`
  height: ${rem(160)};
  max-height: none;
  max-width: 90%;
  margin-bottom: -${rem(2)};
`;

const CatTitle = styled.h3`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.headings};
  font-size: ${rem(22)};
  font-weight: 700;
  line-height: 1.3;
  color: ${MAROON};
`;

const CatSubLink = styled(Link)`
  font-size: ${rem(15)};
  line-height: 1.4;
  color: ${DARK};
  text-decoration: underline;

  &:hover {
    color: ${RED};
    text-decoration: underline;
  }
`;

const UniversalSetsSlider = styled(SliderStack)`
  /* Headroom for the set images poking 40px above the folders. */
  padding-top: ${rem(32)};
`;

interface PonukaProps {
  categoriesGroup: any[];
}

const getThumb = (category: any): string | undefined => {
  const photogallery = prop(category, 'content.photogallery');
  const path = prop(
    photogallery && photogallery.length && photogallery[0],
    'document_path',
  );
  return path
    ? `${getImagePath(path, { width: 400, height: 400 })}&transparent=1`
    : undefined;
};

const getCategoryUrl = (category: any): string => {
  if (category.uniqid_url) {
    return getUrl(category.uniqid_url);
  }
  const categories = category.categories;
  return categories && categories.length && categories[0] && categories[0].url
    ? getUrl(categories[0].url)
    : '/';
};

const PonukaBase = ({ categoriesGroup }: PonukaProps) => {
  const { carouselRef, canLeft, canRight, updateArrows, scroll } =
    useCarousel(284);

  const categories = (categoriesGroup || []).filter(
    (c: any) =>
      c &&
      c.name &&
      c.uniqid !== 'FURNITURE_SCHOOL' &&
      (c.uniqid_url || (c.categories || []).length),
  );

  React.useEffect(() => {
    updateArrows();
  }, [categories.length, updateArrows]);

  return (
    <PonukaWrap>
      <PonukaTitle as="h2">
        {__('Ponuka ')}
        <PonukaTitleAccent>{__('produktov')}</PonukaTitleAccent>
      </PonukaTitle>

      {categories.length > 0 && (
        <ProductsSliderWrapper>
          <CarouselWrap>
            <CarouselTrack ref={carouselRef} onScroll={updateArrows}>
              {categories.map((cat: any) => {
                const thumb = getThumb(cat);
                const subs = (cat.categories || []).slice(0, 5);
                return (
                  <SlideCard key={cat.uniqid_url || cat.name}>
                    <CatFolder>
                      {thumb ? (
                        <CatImg
                          src={thumb}
                          alt=""
                          aria-hidden="true"
                          loading="lazy"
                          decoding="async"
                        />
                      ) : null}
                    </CatFolder>
                    <ProductBody>
                      <CatTitle>{capitalizeFirstLetter(cat.name)}</CatTitle>
                      <ProductList>
                        {subs.map((sub: any) => (
                          <ProductItem key={sub.url}>
                            <CatSubLink to={getUrl(sub.url)}>
                              {sub.category_name}
                            </CatSubLink>
                          </ProductItem>
                        ))}
                      </ProductList>
                      <ProductButtonRow>
                        <PillButton to={getCategoryUrl(cat)}>
                          {__('Zobraziť všetko')}
                        </PillButton>
                      </ProductButtonRow>
                    </ProductBody>
                  </SlideCard>
                );
              })}
            </CarouselTrack>
            <SlideOverlayArrow
              type="button"
              className={`left${canLeft ? '' : ' hidden'}`}
              onClick={() => scroll(-1)}
              aria-label={__('Predošlé')}
            >
              <Chevron dir="left" />
            </SlideOverlayArrow>
            <SlideOverlayArrow
              type="button"
              className={`right${canRight ? '' : ' hidden'}`}
              onClick={() => scroll(1)}
              aria-label={__('Ďalšie')}
            >
              <Chevron dir="right" />
            </SlideOverlayArrow>
          </CarouselWrap>
          <MobileArrows>
            <ArrowButton onClick={() => scroll(-1)} aria-label={__('Predošlé')}>
              <Chevron dir="left" />
            </ArrowButton>
            <ArrowButton onClick={() => scroll(1)} aria-label={__('Ďalšie')}>
              <Chevron dir="right" />
            </ArrowButton>
          </MobileArrows>
        </ProductsSliderWrapper>
      )}
    </PonukaWrap>
  );
};

const PonukaSection = connect((state: any) => ({
  categoriesGroup: state.general.categoriesGroup || [],
}))(PonukaBase);

/* =================================================================== *
 * Section 5 — Referencie: the three homepage reviews (Google / Facebook
 * / after-order), each an HTML body from `reviewTexts`. Grey block.
 * =================================================================== */

const References = styled(SliderSection)`
  position: relative;
  z-index: 3;
  background: ${audienceColor('grayLight')};
  /* Top corners rounded, bottom square (Figma) — last block on the page. Tucks
     over the white Ponuka block like the other sections. */
  border-radius: ${rem(24)} ${rem(24)} 0 0;
  margin-top: -${rem(40)};
  padding: ${rem(16)} 0 ${rem(32)};
  ${({ theme }) => theme.media('md')} {
    margin-top: -${rem(82)};
    border-radius: ${rem(42)} ${rem(42)} 0 0;
    padding: ${rem(40)} 0 ${rem(60)};
  }
  & ${OverlayArrow}, & ${ArrowButton} {
    background: ${DARK};
    &:hover {
      background: ${({ theme }) => theme.color.black};
    }
  }
`;

const RefHeaderButton = styled(YellowButton)`
  display: none;
  ${({ theme }) => theme.media('md')} {
    display: inline-flex;
    flex: 0 0 auto;
  }
`;

const MobileRefButton = styled(YellowButton)`
  align-self: stretch;
  justify-content: center;
  margin: 0 ${rem(16)};
  ${({ theme }) => theme.media('md')} {
    display: none;
  }
`;

const RefCard = styled.div`
  scroll-snap-align: start;
  flex: 0 0 ${rem(300)};
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  background: ${({ theme }) => theme.color.white};
  border-radius: ${rem(16)};
  box-shadow: ${CARD_SHADOW};
  padding: ${rem(24)};
  ${({ theme }) => theme.media('md')} {
    flex: 0 0 ${rem(384)};
  }
`;

const RefHead = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(10)};
`;

const RefHeadIcon = styled.img`
  width: ${rem(28)};
  height: ${rem(28)};
`;

const RefGoogleLogo = styled.img`
  width: ${rem(28)};
  height: ${rem(28)};
`;

const RefFacebookLogo = styled.img`
  width: ${rem(28)};
  height: ${rem(28)};
`;

const RefHeadText = styled.span`
  font-size: ${rem(18)};
  font-weight: 600;
  color: ${DARK};
`;

const RefBody = styled.div`
  /* Fill the card (cards stretch to equal height in the row) and lay the content
     out as a column, so the "Zobraziť viac referencií" link can sit at the very
     bottom regardless of how long the review text above it is. */
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  font-size: ${rem(15)};
  line-height: 1.6;
  color: ${DARK};

  p {
    margin: 0 0 ${rem(8)};
  }

  /* Google / FB reviews (markup: <p>text</p><p>rating img</p><p>link</p>): keep
     the review text at the top and push everything after it — the reviewer /
     rating block and the "Zobraziť viac referencií" link — to the bottom, so the
     link always sits at the very bottom of the card (Figma node 3186-29461). The
     after-order card (.with-avatar) has no link, so it is left as-is. */
  &:not(.with-avatar) > p:nth-child(2) {
    margin-top: auto;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
    margin-top: ${rem(8)};
  }

  /* Only the "Hodnotenie po nákupe" card (.with-avatar) ends with the reviewer
     name — render it with a user avatar. Google/FB cards must never get it, so
     the rule is scoped to that card rather than relying on their markup. */
  &.with-avatar p:last-child {
    display: flex;
    align-items: center;
    gap: ${rem(10)};
    margin: ${rem(12)} 0 0 !important;
    font-size: ${rem(15)} !important;

    &::before {
      content: '';
      flex: 0 0 auto;
      width: ${rem(40)};
      height: ${rem(40)};
      background: url('${ASSET}/ico-user.svg') center / contain no-repeat;
    }

    b {
      font-weight: 700;
    }
  }

  /* "Zobraziť viac referencií" link (Google/FB) — repositioned + restyled with a
     chevron, overriding the inline float/size from the CMS content. */
  a {
    float: none !important;
    display: inline-flex;
    align-items: center;
    gap: ${rem(6)};
    margin-top: ${rem(16)};
    color: ${DARK} !important;
    font-size: ${rem(16)} !important;
    font-weight: 600;
    text-decoration: underline;

    &::after {
      content: '';
      width: ${rem(16)};
      height: ${rem(16)};
      background: url('${ASSET}/ico-chevron-right.svg') center / contain
        no-repeat;
    }
  }
`;

/* Section tucks depend on this gap: margin-top = −(gap + section radius). */
const ContentBoxWrapper = styled(ContentBox)`
  padding-bottom: ${rem(0)} !important;
  gap: ${rem(16)};
  ${({ theme }) => theme.media('md')} {
    gap: ${rem(40)};
  }
`;

const ProductsSliderWrapper = styled(SliderStack)`
  /* Headroom for the category images poking above the folders. */
  padding-top: ${rem(32)};
`;

interface ReviewsProps {
  reviewTexts: any[];
}

const findReview = (reviewTexts: any[], id: string): string | undefined => {
  const found = (reviewTexts || []).find((r: any) => r.text_id === id);
  const body = found?.content?.json_content?.body;
  return typeof body === 'string' && body ? body : undefined;
};

const ReferencesBase = ({ reviewTexts }: ReviewsProps) => {
  const { carouselRef, canLeft, canRight, updateArrows, scroll } =
    useCarousel(324);

  const google = findReview(reviewTexts, 'HOMEPAGE_REVIEW_GOOGLE');
  const google2 = findReview(reviewTexts, 'HOMEPAGE_REVIEW_GOOGLE_2');
  const facebook = findReview(reviewTexts, 'HOMEPAGE_REVIEW_FACEBOOK');
  const facebook2 = findReview(reviewTexts, 'HOMEPAGE_REVIEW_FACEBOOK_2');
  const afterOrder = findReview(reviewTexts, 'HOMEPAGE_REVIEW_AFTER_ORDER');

  const googleHead = (
    <>
      <RefGoogleLogo
        src={`${ASSET}/ico-google.svg`}
        alt="Google"
        loading="lazy"
        decoding="async"
      />
      <RefHeadText>{__('Recenzie')}</RefHeadText>
    </>
  );
  const facebookHead = (
    <>
      <RefFacebookLogo
        src={`${ASSET}/ico-facebook.svg`}
        alt="Facebook"
        loading="lazy"
        decoding="async"
      />
      <RefHeadText>{__('Recenzie')}</RefHeadText>
    </>
  );

  const cards: {
    head: React.ReactNode;
    body: string;
    avatar?: boolean;
  }[] = [];
  if (afterOrder) {
    cards.push({
      head: (
        <>
          <RefHeadIcon
            src={`${ASSET}/ico-basket.svg`}
            alt=""
            aria-hidden="true"
            loading="lazy"
            decoding="async"
          />
          <RefHeadText>{__('Hodnotenie po nákupe')}</RefHeadText>
        </>
      ),
      body: afterOrder,
      avatar: true,
    });
  }
  if (google) {
    cards.push({ head: googleHead, body: google });
  }
  if (google2) {
    cards.push({ head: googleHead, body: google2 });
  }
  if (facebook) {
    cards.push({ head: facebookHead, body: facebook });
  }
  if (facebook2) {
    cards.push({ head: facebookHead, body: facebook2 });
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    updateArrows();
  }, [cards.length, updateArrows]);

  if (!cards.length) {
    return null;
  }

  return (
    <References>
      <SliderHeader>
        <SectionTitle>{__('Referencie')}</SectionTitle>
        <RefHeaderButton
          as="a"
          href={REVIEWS_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {__('Zobraziť všetky referencie')}
        </RefHeaderButton>
      </SliderHeader>
      <SliderStack>
        <CarouselWrap>
          <CarouselTrack ref={carouselRef} onScroll={updateArrows}>
            {cards.map((c, i) => (
              <RefCard key={i}>
                <RefHead>{c.head}</RefHead>
                <RefBody
                  className={c.avatar ? 'with-avatar' : undefined}
                  dangerouslySetInnerHTML={{
                    __html: c.body.replace(
                      /ZOBRAZIŤ VIAC RECENZIÍ/g,
                      __('Zobraziť viac referencií'),
                    ),
                  }}
                />
              </RefCard>
            ))}
          </CarouselTrack>
          <SlideOverlayArrow
            type="button"
            className={`left${canLeft ? '' : ' hidden'}`}
            onClick={() => scroll(-1)}
            aria-label={__('Predošlé')}
          >
            <Chevron dir="left" />
          </SlideOverlayArrow>
          <SlideOverlayArrow
            type="button"
            className={`right${canRight ? '' : ' hidden'}`}
            onClick={() => scroll(1)}
            aria-label={__('Ďalšie')}
          >
            <Chevron dir="right" />
          </SlideOverlayArrow>
        </CarouselWrap>
        <MobileArrows>
          <ArrowButton onClick={() => scroll(-1)} aria-label={__('Predošlé')}>
            <Chevron dir="left" />
          </ArrowButton>
          <ArrowButton onClick={() => scroll(1)} aria-label={__('Ďalšie')}>
            <Chevron dir="right" />
          </ArrowButton>
        </MobileArrows>
        <MobileRefButton
          as="a"
          href={REVIEWS_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {__('Zobraziť všetky referencie')}
        </MobileRefButton>
      </SliderStack>
    </References>
  );
};

const ReferencesSection = connect((state: any) => ({
  reviewTexts: prop(state.home, 'reviewTexts', []),
}))(ReferencesBase);

/* ------------------------------------------------------------------ */

interface SelfIntroProps {
  metaTags?: any;
  settings?: any;
  user?: any;
  isFetchingUser?: boolean;
  eshop?: any;
  loaded?: boolean;
  isError?: boolean;
}

const SelfIntroBase = ({
  metaTags,
  settings,
  user,
  isFetchingUser,
  eshop,
  loaded,
  isError,
}: SelfIntroProps) => {
  const showSkvelko =
    isSkvelkoHomepageEnabled(settings) &&
    !isFetchingUser &&
    canShowHomepageSkvelkoSearch(user);

  if (eshop || (isHomepageEshopEnabled(settings) && !loaded && !isError)) {
    return (
      <>
        <MetaTags tags={metaTags || { title: 'Daffer.sk' }} />
        <Helmet>
          <link rel="canonical" href={`${SITE_ORIGIN}/`} />
        </Helmet>
        <StructuredData webSite />
        <UrlMapperView {...eshop} isHomepage={true} />
      </>
    );
  }

  return (
    <Page>
      {metaTags ? (
        <MetaTags tags={metaTags} />
      ) : (
        <MetaTags tags={{ title: 'Daffer.sk' }} />
      )}
      {/* Preload the LCP banner photo (CSS backgrounds are discovered late)
          + the canonical URL (nothing else in the app renders one). */}
      <Helmet>
        <link rel="canonical" href={`${SITE_ORIGIN}/`} />
        <link
          rel="preload"
          as="image"
          href={`${ASSET}/support.webp`}
          {...({ fetchpriority: 'high' } as any)}
        />
      </Helmet>
      <StructuredData webSite />
      <ContentBoxWrapper>
        {/* <DeliveryBannerSection /> */}
        <SupportBannerSection />
        <PromoBoxesSection tuckedBelow={!showSkvelko} />
        {showSkvelko && <SkvelkoSection />}
        <PromoSection />
        <UniversalSets />
        <PonukaSection />
        <ReferencesSection />
      </ContentBoxWrapper>
    </Page>
  );
};

const loadSettings = async (dispatch: any) => {
  const getSettings = () =>
    dispatch((_dispatch, getState) => getState().general.settings);
  if (!('homepageEshop' in (getSettings() || {}))) {
    await dispatch(loadDefaultSettings());
  }
  return getSettings();
};

(SelfIntroBase as any).getInitialProps = async (parentProps: any) => {
  try {
    const settings = await loadSettings(parentProps.dispatch);
    if (isHomepageEshopEnabled(settings)) {
      const [eshop] = await Promise.all([
        UrlMapper.getInitialProps({
          ...parentProps,
          location: { ...parentProps.location, pathname: URL_ESHOP_ENTRY },
        }),
        parentProps.dispatch(loadGlobalMetaTags(HOMEPAGE_UNIQID)),
      ]);
      if (eshop?.urlMapData?.type === UrlMapTypes.CategoryGroup) {
        return { eshop };
      }
    }

    const promises: any[] = [];
    promises.push(parentProps.dispatch(loadSkvelkoCities()));
    promises.push(parentProps.dispatch(loadUniversalSets()));
    promises.push(parentProps.dispatch(loadReviewsTexts()));
    promises.push(parentProps.dispatch(loadHomepagePromoBanners()));
    promises.push(parentProps.dispatch(loadGlobalMetaTags(HOMEPAGE_UNIQID)));
    await Promise.all(promises);
    return { loaded: true };
  } catch (e) {
    return { isError: true };
  }
};

const mapStateToProps = (state: any) => ({
  metaTags: prop(state.general, `globalMetaTags.${HOMEPAGE_UNIQID}`),
  settings: state.general.settings,
  user: state.auth.user,
  isFetchingUser: state.auth.isFetchingUser,
});

export const SelfIntro = connect(mapStateToProps)(
  connectSsr({ displayName: 'SelfIntro' })(SelfIntroBase),
);

export default SelfIntro;
